/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_All_StatusesInputs */

const en_automation_runs_all_statuses = /** @type {(inputs: Automation_Runs_All_StatusesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All statuses`)
};

const pt_br2_automation_runs_all_statuses = /** @type {(inputs: Automation_Runs_All_StatusesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os status`)
};

/**
* | output |
* | --- |
* | "All statuses" |
*
* @param {Automation_Runs_All_StatusesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_all_statuses = /** @type {((inputs?: Automation_Runs_All_StatusesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_All_StatusesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_all_statuses(inputs)
	return pt_br2_automation_runs_all_statuses(inputs)
});